/* GYMKUMA quick add — collection card
   Delegated listeners so it survives the AJAX filter re-rendering the grid. */
(function () {
  if (window.__gkQuickAdd) return;
  window.__gkQuickAdd = true;

  var ADD_URL = ((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js';

  function closeAll(except) {
    var open = document.querySelectorAll('[data-quick-add].is-open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] === except) continue;
      open[i].classList.remove('is-open');
      var panel = open[i].querySelector('[data-quick-add-panel]');
      if (panel) panel.hidden = true;
    }
  }

  function openCart() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );

    var trigger = document.querySelector(
      '[data-action="open-drawer"][data-drawer-id="sidebar-cart"]'
    );

    if (trigger) {
      setTimeout(function () {
        trigger.click();
      }, 300);
    }
  }

  function addToCart(variantId, root) {
    if (!variantId || root.classList.contains('is-loading')) return;

    root.classList.remove('is-error');
    root.classList.add('is-loading');

    fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add_failed');
        return response.json();
      })
      .then(function () {
        root.classList.remove('is-loading');
        root.classList.add('is-added');
        closeAll();
        openCart();
        setTimeout(function () {
          root.classList.remove('is-added');
        }, 2000);
      })
      .catch(function () {
        root.classList.remove('is-loading');
        root.classList.add('is-error');
        setTimeout(function () {
          root.classList.remove('is-error');
        }, 2500);
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var option = target.closest('[data-quick-add-option]');
      if (option) {
        event.preventDefault();
        event.stopPropagation();
        if (option.disabled) return;
        addToCart(option.getAttribute('data-variant-id'), option.closest('[data-quick-add]'));
        return;
      }

      var trigger = target.closest('[data-quick-add-trigger]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        if (trigger.disabled) return;

        var root = trigger.closest('[data-quick-add]');
        var directVariant = trigger.getAttribute('data-variant-id');

        if (directVariant) {
          addToCart(directVariant, root);
          return;
        }

        var panel = root.querySelector('[data-quick-add-panel]');
        var wasOpen = root.classList.contains('is-open');
        closeAll(root);

        if (wasOpen) {
          root.classList.remove('is-open');
          if (panel) panel.hidden = true;
        } else {
          root.classList.add('is-open');
          if (panel) panel.hidden = false;
        }
        return;
      }

      if (!target.closest('[data-quick-add]')) closeAll();
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.keyCode === 27) closeAll();
  });
})();
